import i18n from 'i18next';
import { html } from 'lit-html';
import moment from 'moment';
import { store } from '../../../app.init';
import Modal from '../../../shared/components/modal/modal';
import Select from '../../../shared/components/selects/select';
import { setAnalysis } from '../../../state/actions';
import { sRender } from '../../../utils/render';
import { getUrlParams, setUrlParam } from '../../../utils/url';

import {
  ANALYSIS_GROUP_ID,
  ANALYSIS_GROUP_ORDER_ID,
} from './analysis-form.service';

const AnalysisFormGroupBy = ({ indicator }) => {
  let disabled = true;
  let values = [];
  let selected = {};

  if (indicator) {
    const res = getValuesAndSelected(indicator.tiempo);
    values = res.values;
    selected = res.selected;
    disabled = false;
  }
  return html`
    <div class="analysis-group-by esios-select">
      <div
        class="esios-analysis__widget-toolbar esios-analysis__widget-toolbar--flex"
      >
        <div class="toolbar-wrapper">
          <h3 class="analysis-group-by__title">${i18n.t('group')}</h3>
          <span class="widget-toolbar-item tooltip-switcher">
            <button
              class="widget-toolbar-info icon-widget-info"
              @click=${openModal}
            ></button>
            <div class="mod-tooltip">
              <p>${i18n.t('more_info')}</p>
            </div>
          </span>
        </div>
      </div>
      ${Select({ disabled, values, selected, onClick: handleGroupBy })}
      <div id="group-modal"></div>
    </div>
  `;
  function openModal() {
    sRender(
      Modal,
      'group-modal',
      i18n.t('group'),
      `<p style='text-transform: none;'>${i18n.t('group_desc')}</p>`
    );
  }
};

function handleGroupBy({ content }) {
  setUrlParam('groupby', content);
  store.dispatch(
    setAnalysis({
      moveBy: content,
    })
  );
  if (content == 'year') {
    let { start_date, end_date } = getUrlParams();
    let endDate = moment(end_date, 'DD-MM-YYYY')
      .endOf('year')
      .format('DD-MM-YYYY');
    let stDate = moment(
      '01-01-' + moment(start_date, 'DD-MM-YYYY').year(),
      'DD-MM-YYYY'
    ).format('DD-MM-YYYY');
    setUrlParam('start_date', stDate + 'T00:00');
    setUrlParam(
      'compare_start_date',
      moment(stDate, 'DD-MM-YYYY').subtract('1', 'year').format('DD-MM-YYYY') +
        'T00:00'
    );
    setUrlParam('end_date', endDate + 'T23:55');
  }

  if (content == 'month') {
    let { start_date } = getUrlParams();
    let stDate = moment(start_date, 'DD-MM-YYYY')
      .startOf('month')
      .subtract('1', 'month')
      .format('DD-MM-YYYY');
    setUrlParam('compare_start_date', stDate + 'T00:00');
    store.dispatch(setAnalysis({ compare_start_date: stDate + 'T00:00' }));
  }
  store.dispatch(setAnalysis({ groupby: content }));
  window.location.reload();
}

function getValuesAndSelected([time]) {
  // Months is not in the old project. See _getTruncs function.
  const disabled = {
    [ANALYSIS_GROUP_ID['minutes5']]: [false, true, true, false, false, false],
    [ANALYSIS_GROUP_ID['minutes10']]: [true, false, true, false, false, false],
    [ANALYSIS_GROUP_ID['minutes15']]: [true, true, false, false, false, false],
    [ANALYSIS_GROUP_ID['hour']]: [true, true, true, false, false, false],
    [ANALYSIS_GROUP_ID['day']]: [true, true, true, true, false, false],
    [ANALYSIS_GROUP_ID['month']]: [true, true, true, true, true, false],
    [ANALYSIS_GROUP_ID['year']]: [true, true, true, true, true, true],
  };
  let timeIdVal;
  if (time.id === 223) {
    timeIdVal = 4;
  } else if (time.id === 154) {
    timeIdVal = 225;
  } else if (time.id === 150) {
    timeIdVal = 3;
  } else {
    timeIdVal = time.id;
  }
  const values = [
    {
      label: i18n.t('minutes5'),
      content: 'minutes5',
      disabled: disabled[timeIdVal][0],
    },
    {
      label: i18n.t('minutes10'),
      content: 'minutes10',
      disabled: disabled[timeIdVal][1],
    },
    {
      label: i18n.t('minutes15'),
      content: 'minutes15',
      disabled: disabled[timeIdVal][2],
    },
    {
      label: i18n.t('hours'),
      content: 'hour',
      disabled: disabled[timeIdVal][3],
    },
    { label: i18n.t('days'), content: 'day', disabled: disabled[timeIdVal][4] },
    {
      label: i18n.t('months'),
      content: 'month',
      disabled: disabled[timeIdVal][5],
    },
    {
      label: i18n.t('years'),
      content: 'year',
      disabled: disabled[timeIdVal][6],
    },
  ];
  const index = ANALYSIS_GROUP_ORDER_ID.indexOf(timeIdVal);
  const { groupby } = getUrlParams();
  let selected = values.find((i) => i.content === groupby);
  if (!groupby) {
    selected = values[index];
  }

  return {
    values,
    selected,
  };
}

export default AnalysisFormGroupBy;
